let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eruLw")).then(() => parcelRequire('8IxMf'));